import { defineStore } from 'pinia'

import { actions } from './actions'
import { createInitialState } from './state'
import { getters } from './getters'

export const useAssessmentResultStore = defineStore('assessment-result', {
  state: createInitialState,
  actions,
  getters,
})
